// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-modal-results {
  max-width: 1216px;
  width: 100%;
}
.content-modal-results .text {
  font-family: Figtree;
  font-size: 12px;
  font-weight: 400;
  color: var(--sebrae-gray);
  line-height: 1.2;
}
.content-modal-results .text-none-recommendations {
  font-family: Figtree;
  font-size: 14px;
  font-weight: 700;
}
.content-modal-results .text-none-recommendations.priority {
  color: #AB6005;
}
.content-modal-results .text-none-recommendations.content {
  color: #2E5DE6;
}
.content-modal-results .text-none-recommendations {
  line-height: 1.2;
}
.content-modal-results .wrapper-priority {
  margin-top: 32px;
}
.content-modal-results .wrapper-priority .list-btn {
  display: flex;
  flex-direction: column;
  max-height: 52px;
  height: auto;
  overflow: hidden;
  transition: max-height 0.35s ease;
}
.content-modal-results .wrapper-priority .list-btn.show {
  max-height: 100vh;
}
.content-modal-results .wrapper-priority .list-btn .btn-default {
  padding: 16px;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Campuni;
  font-size: 12px;
  font-weight: bold;
}
.content-modal-results .wrapper-priority .list-btn .btn-default.priority {
  color: #AB6005;
  background-color: #FFFAE6;
}
.content-modal-results .wrapper-priority .list-btn .btn-default.priority.selected {
  order: 1;
}
.content-modal-results .wrapper-priority .list-btn .btn-default.priority.not-selected {
  order: 2;
}
.content-modal-results .wrapper-priority .list-btn .btn-default.content {
  color: var(--sebrae-blue-6);
  background-color: var(--sebrae-white-3);
}
.content-modal-results .wrapper-priority .list-btn .btn-default.content.selected {
  order: 1;
}
.content-modal-results .wrapper-priority .list-btn .btn-default.content.not-selected {
  order: 2;
}
.content-modal-results .content-priority {
  padding: 16px;
}
.content-modal-results .content-priority.priority {
  background-color: #FFFAE6;
}
.content-modal-results .content-priority.priority .list-cards.showPriorityCards {
  display: grid;
}
.content-modal-results .content-priority.priority .list-cards.hiddenPriorityCards {
  display: none;
}
.content-modal-results .content-priority.priority .text.showPriority {
  display: block;
}
.content-modal-results .content-priority.priority .text.hiddenPriority {
  display: none;
}
.content-modal-results .content-priority.content {
  background-color: var(--sebrae-white-3);
}
.content-modal-results .content-priority.content .list-cards.showContentCards {
  display: grid;
}
.content-modal-results .content-priority.content .list-cards.hiddenContentCards {
  display: none;
  margin: 0;
}
.content-modal-results .content-priority.content .text.showContent {
  display: block;
}
.content-modal-results .content-priority.content .text.hiddenContent {
  display: none;
}
.content-modal-results .list-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(auto, 280px));
  row-gap: 16px;
  column-gap: 16px;
  margin-top: 16px;
  justify-content: center;
}
.content-modal-results .list-cards.content {
  grid-template-columns: repeat(auto-fit, minmax(auto, 212px));
}
@media (min-width: 507px) {
  .content-modal-results .wrapper-priority .list-btn {
    padding-inline: 8px;
    flex-direction: row;
    gap: 16px;
    height: 100%;
  }
  .content-modal-results .wrapper-priority .list-btn .btn-default {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .content-modal-results .wrapper-priority .list-btn .btn-default .wrapper-icon {
    display: none;
  }
  .content-modal-results .wrapper-priority .list-btn .btn-default.priority.selected {
    order: 0;
    opacity: 100%;
  }
  .content-modal-results .wrapper-priority .list-btn .btn-default.priority.not-selected {
    order: 0;
    opacity: 50%;
  }
  .content-modal-results .wrapper-priority .list-btn .btn-default.content.selected {
    order: 0;
    opacity: 100%;
  }
  .content-modal-results .wrapper-priority .list-btn .btn-default.content.not-selected {
    order: 0;
    opacity: 50%;
  }
  .content-modal-results .list-cards {
    justify-content: flex-start;
  }
  .content-modal-results .text-none-recommendations {
    font-size: 16px;
  }
}
@media (min-width: 768px) {
  .content-modal-results .text {
    font-size: 16px;
  }
  .content-modal-results .wrapper-priority .list-btn .btn-default {
    font-size: 19px;
  }
  .content-modal-results .content-priority {
    padding: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/planning/components/body-result/index.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,WAAA;AACJ;AACI;EAEQ,oBAAA;EACA,eAAA;EACA,gBAAA;EAGJ,yBAAA;EACA,gBAAA;AAFR;AAKI;EAEQ,oBAAA;EACA,eAAA;EACA,gBAAA;AAJZ;AAOQ;EACI,cAAA;AALZ;AAQQ;EACI,cAAA;AANZ;AANI;EAeI,gBAAA;AANR;AASI;EACI,gBAAA;AAPR;AASQ;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;AAPZ;AASY;EACI,iBAAA;AAPhB;AAUY;EACI,aAAA;EACA,WAAA;EACA,eAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;EAGI,oBAAA;EACA,eAAA;EACA,iBAAA;AAXpB;AAcgB;EACI,cAAA;EACA,yBAAA;AAZpB;AAcoB;EACI,QAAA;AAZxB;AAeoB;EACI,QAAA;AAbxB;AAiBgB;EACI,2BAAA;EACA,uCAAA;AAfpB;AAiBoB;EACI,QAAA;AAfxB;AAkBoB;EACI,QAAA;AAhBxB;AAuBI;EACI,aAAA;AArBR;AAwBQ;EACI,yBAAA;AAtBZ;AAwBoB;EACI,aAAA;AAtBxB;AAyBoB;EACI,aAAA;AAvBxB;AA4BgB;EACI,cAAA;AA1BpB;AA6BgB;EACI,aAAA;AA3BpB;AAgCQ;EACI,uCAAA;AA9BZ;AAgCgB;EACI,aAAA;AA9BpB;AAiCgB;EACI,aAAA;EACA,SAAA;AA/BpB;AAoCgB;EACI,cAAA;AAlCpB;AAqCgB;EACI,aAAA;AAnCpB;AAyCI;EACI,aAAA;EACA,4DAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAvCR;AAyCQ;EACI,4DAAA;AAvCZ;AA2CI;EAEQ;IACI,mBAAA;IACA,mBAAA;IACA,SAAA;IACA,YAAA;EA1Cd;EA4Cc;IACI,4BAAA;IACA,6BAAA;EA1ClB;EA4CkB;IACI,aAAA;EA1CtB;EA8CsB;IACI,QAAA;IACA,aAAA;EA5C1B;EA+CsB;IACI,QAAA;IACA,YAAA;EA7C1B;EAkDsB;IACI,QAAA;IACA,aAAA;EAhD1B;EAmDsB;IACI,QAAA;IACA,YAAA;EAjD1B;EAwDM;IACI,2BAAA;EAtDV;EAyDM;IACI,eAAA;EAvDV;AACF;AA4DI;EACI;IACI,eAAA;EA1DV;EA+Dc;IACI,eAAA;EA7DlB;EAmEM;IACI,aAAA;EAjEV;AACF","sourcesContent":[".content-modal-results {\n    max-width: 1216px;\n    width: 100%;\n\n    .text {\n        font: {\n            family: Figtree;\n            size: 12px;\n            weight: 400;\n        }\n\n        color: var(--sebrae-gray);\n        line-height: 1.2;\n    }\n\n    .text-none-recommendations {\n        font: {\n            family: Figtree;\n            size: 14px;\n            weight: 700;\n        }\n\n        &.priority {\n            color: #AB6005;\n        }\n\n        &.content {\n            color: #2E5DE6;\n        }\n\n        line-height: 1.2;\n    }\n\n    .wrapper-priority {\n        margin-top: 32px;\n\n        .list-btn {\n            display: flex;\n            flex-direction: column;\n            max-height: 52px;\n            height: auto;\n            overflow: hidden;\n            transition: max-height .35s ease;\n\n            &.show {\n                max-height: 100vh;\n            }\n\n            .btn-default {\n                padding: 16px;\n                width: 100%;\n                cursor: pointer;\n                // border-radius: 10px;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n\n                font: {\n                    family: Campuni;\n                    size: 12px;\n                    weight: bold;\n                }\n\n                &.priority {\n                    color: #AB6005;\n                    background-color: #FFFAE6;\n\n                    &.selected {\n                        order: 1;\n                    }\n\n                    &.not-selected {\n                        order: 2;\n                    }\n                }\n\n                &.content {\n                    color: var(--sebrae-blue-6);\n                    background-color: var(--sebrae-white-3);\n\n                    &.selected {\n                        order: 1;\n                    }\n\n                    &.not-selected {\n                        order: 2;\n                    }\n                }\n            }\n        }\n    }\n\n    .content-priority {\n        padding: 16px;\n\n\n        &.priority {\n            background-color: #FFFAE6;\n            .list-cards{\n                    &.showPriorityCards {\n                        display: grid;\n                    }\n        \n                    &.hiddenPriorityCards {\n                        display: none;\n                    }\n            }\n\n            .text {\n                &.showPriority {\n                    display: block;\n                }\n\n                &.hiddenPriority {\n                    display: none;\n                }\n            }\n        }\n\n        &.content {\n            background-color: var(--sebrae-white-3);\n            .list-cards{\n                &.showContentCards {\n                    display: grid;\n                }\n    \n                &.hiddenContentCards {\n                    display: none;\n                    margin: 0;\n                }\n            }\n\n            .text {\n                &.showContent {\n                    display: block;\n                }\n\n                &.hiddenContent {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    .list-cards {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(auto, 280px));\n        row-gap: 16px;\n        column-gap: 16px;\n        margin-top: 16px;\n        justify-content: center;\n\n        &.content {\n            grid-template-columns: repeat(auto-fit, minmax(auto, 212px));\n        }\n    }\n\n    @media(min-width: 507px) {\n        .wrapper-priority {\n            .list-btn {\n                padding-inline: 8px;\n                flex-direction: row;\n                gap: 16px;\n                height: 100%;\n\n                .btn-default {\n                    border-top-left-radius: 10px;\n                    border-top-right-radius: 10px;\n\n                    .wrapper-icon {\n                        display: none;\n                    }\n\n                    &.priority {\n                        &.selected {\n                            order: 0;\n                            opacity: 100%;\n                        }\n\n                        &.not-selected {\n                            order: 0;\n                            opacity: 50%;\n                        }\n                    }\n\n                    &.content {\n                        &.selected {\n                            order: 0;\n                            opacity: 100%;\n                        }\n\n                        &.not-selected {\n                            order: 0;\n                            opacity: 50%;\n                        }\n                    }\n                }\n            }\n        }\n\n        .list-cards {\n            justify-content: flex-start;\n        }\n\n        .text-none-recommendations {\n            font-size: 16px;\n        }\n    }\n\n\n\n    @media(min-width: 768px) {\n        .text {\n            font-size: 16px;\n        }\n\n        .wrapper-priority {\n            .list-btn {\n                .btn-default {\n                    font-size: 19px;\n                }\n            }\n\n        }\n\n        .content-priority {\n            padding: 24px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
